import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public showSpinner$ = this.showSpinner.asObservable();



}